import type { RouteRecordRaw } from 'vue-router'
import { coreRoutes } from './core.routes'
import { agendamientoRoutes } from './agendamiento.routes'
import { admisionRoutes } from './admision.routes'
import { asistencialRoutes } from './asistencial.routes'
import { plantillasHcRoutes } from './plantillasHc.routes'
import { reportesRoutes } from './reportes.routes'
import { demandaInducidaRoutes } from './demandaInducida.routes'
import { repositoriosRoutes } from './repositorios.routes'
import { tareasRoutes } from './tareas.routes'
import { farmaciaRoutes } from './farmacia.routes'
import { insumosRoutes } from './insumos.routes'
import { financieraRoutes } from './financiera.routes'
import { facturacionRoutes } from './facturacion.routes'
import { portalRoutes } from './portal.routes'
import { administracionRoutes } from './administracion.routes'
import { analiticaRoutes } from './analitica.routes'
import { configuracionRoutes } from './configuracion.routes'
import { soporteRoutes } from './soporte.routes'
import { authRoutes } from './auth.routes'

// Layout principal (LayoutIndex) con todas las rutas de los modulos como hijos.
// Cada modulo vive en su propio archivo ./<modulo>.routes.ts; aqui solo se
// componen. El ORDEN se conserva identico al original.
const routes = [
  {
    path: '/',
    component: () =>
      import(
        /* webpackChunkName: "base" */ '@/modules/Core/views/LayoutIndex.vue'
      ),
    menu: false,
    desplegable: false,
    icon: '',
    redirect: '/inicio',
    meta: {
      permiso: [],
      requiresSession: true,
      title: 'Inicio'
    },
    children: [
      ...coreRoutes
      ,...agendamientoRoutes
      ,...admisionRoutes
      ,...asistencialRoutes
      ,...plantillasHcRoutes
      ,...reportesRoutes
      ,...demandaInducidaRoutes
      ,...repositoriosRoutes
      ,...tareasRoutes
      ,...farmaciaRoutes
      ,...insumosRoutes
      ,...financieraRoutes
      ,...facturacionRoutes
      ,...portalRoutes
      ,...administracionRoutes
      ,...analiticaRoutes
      ,...configuracionRoutes
      ,...soporteRoutes
    ]
  },
  // Layout de autenticacion (login, solicitud, recuperar, error503)
  ...authRoutes
]

export default routes as Array<RouteRecordRaw>
